import * as React from "react";
import {Link} from "react-router-dom";

interface IProps {
    isTop: boolean;
    link?: string;
    onButtonPress?: () => void;
}

export class BackButton extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        if (this.props.link) {
            return (
                <div className={`${this.props.isTop ? "back-link-top" : "back-link-bottom"}`}>
                    <Link to={this.props.link}>
                        <button type="button" className={`btn btn-back-link`} onClick={this.props.onButtonPress!}>Back</button>
                    </Link>
                </div>
            )
        }

        return (
            <div className={`${this.props.isTop ? "back-link-top" : "back-link-bottom"}`}>
                <a onClick={this.goBack}>
                    <button type="button" role="link" className={`btn btn-back-link`} onClick={this.props.onButtonPress!}>Back</button>
                </a>
            </div>
        )
    }

    private goBack(event: any) {
        event.target.href = window.history.back();
    }
}

